import { render, staticRenderFns } from "./comTabs.vue?vue&type=template&id=123a41be&scoped=true&"
import script from "./comTabs.vue?vue&type=script&lang=js&"
export * from "./comTabs.vue?vue&type=script&lang=js&"
import style0 from "./comTabs.vue?vue&type=style&index=0&id=123a41be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a41be",
  null
  
)

export default component.exports